import { Component, computed, input } from "@angular/core";
import { NgTemplateOutlet } from "@angular/common";

import { TranslateModule } from "@ngx-translate/core";
import {
	FunctionALPackageType,
	FunctionALTreatmentPackages,
} from "libs/treatments/src/lib/models/treatment.model";
import { FunctionALPackagesService } from "libs/treatments/src/lib/services";
import { MatTooltipModule } from "@angular/material/tooltip";

@Component({
	selector: "lib-treatment-packages-functional",
	imports: [TranslateModule, NgTemplateOutlet, MatTooltipModule],
	templateUrl: "./treatment-packages-functional.component.html",
	styleUrl: "./treatment-packages-functional.component.scss",
})
export class TreatmentPackagesFunctionALComponent {
	readonly packages = input.required<FunctionALTreatmentPackages>();

	FunctionALPackageType = FunctionALPackageType;

	readonly isRefinementPackagePlanned = computed(
		() =>
			this.packages().plannedRefinementAligners !== undefined &&
			this.packages().plannedRefinementAligners > 0
	);

	protected hasRefinementPackages(): boolean {
		return FunctionALPackagesService.hasPackageOfType(this.packages(), FunctionALPackageType.REFINEMENT);
	}

	protected hasChargeableRefinementPackages(): boolean {
		return FunctionALPackagesService.hasPackageOfType(
			this.packages(),
			FunctionALPackageType.CHARGEABLE_REFINEMENT
		);
	}
}
